import { useCallback, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ModalsList } from '../constants';
import { useStores } from '../stores';

export const useCustomNavigation = () => {
  const { modalStore } = useStores();
  const navigate = useNavigate();
  const location = useLocation();
  const { showModal, hideModal } = modalStore;
  const pendingPathRef = useRef('/');

  const confirmNavigation = useCallback(() => {
    if (pendingPathRef.current !== null) {
      navigate(pendingPathRef.current);
      pendingPathRef.current = '/';
    }
    hideModal();
  }, [navigate, hideModal]);

  const handleNavigationAttempt = useCallback(
    path => {
      pendingPathRef.current = path;
      if (location.pathname.includes('/edit') || location.pathname.includes('/create')) {
        showModal(ModalsList.CancelationModal.name, confirmNavigation);
      } else {
        navigate(path);
      }
    },
    [location.pathname, navigate, showModal]
  );

  return handleNavigationAttempt;
};
